// Roving tabindex (WAI-ARIA APG): one tab stop per group, arrow keys move within it, Home / End jump to the
// ends. Shared by Segmented (radio group) and Tabs (tablist), both with automatic activation — moving the
// focus also selects, so the arrow keys never leave a control "focused but not chosen".

export type RovingKey = 'ArrowRight' | 'ArrowLeft' | 'ArrowDown' | 'ArrowUp' | 'Home' | 'End';

/**
 * The index the focus moves to for a key, or null when the key is not a roving key. Wraps at both ends
 * (APG "Tabs" and "Radio Group" patterns). `count` must be ≥ 1.
 */
export function nextRovingIndex(key: string, index: number, count: number): number | null {
  switch (key) {
    case 'ArrowRight':
    case 'ArrowDown':
      return (index + 1) % count;
    case 'ArrowLeft':
    case 'ArrowUp':
      return (index - 1 + count) % count;
    case 'Home':
      return 0;
    case 'End':
      return count - 1;
    default:
      return null;
  }
}
